var React = require('react');

function ControlCenter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 0H2V3.25H0V4.75H2V8H7V0Z","fill":"#181818","key":0}),React.createElement("path",{"d":"M9 4.75H16V3.25H9V4.75Z","fill":"#181818","key":1}),React.createElement("path",{"d":"M9 8H14V11.25H16V12.75H14V16H9V8Z","fill":"#181818","key":2}),React.createElement("path",{"d":"M0 12.75H7V11.25H0V12.75Z","fill":"#181818","key":3})]);
}

ControlCenter.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ControlCenter;

ControlCenter.default = ControlCenter;
